export default "__VITE_ASSET__C8sNQ9T5__"